<template>
  <section class="bg-default h-full w-full">
      <div id="errorPage">
          <div class="container">
            <router-view />
          </div>
      </div>
  </section>
</template>

<script>
import '~/assets/scss/pages/_error.scss';

export default {
  components: {
  },
  data() {
    return {
    };
  },
};
</script>
